export default __webpack_public_path__ + "static/media/report-complete.50f9ddbe.gif";